/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('LinksController', ['$scope', 'Settings', 'headerService', 'NodeWithLinks', '$translate',
        function ($scope, Settings, headerService, NodeWithLinks, $translate) {
            $translate('Links').then(function (translation) {
                headerService.addBreadcrumbsRootItem(translation, null);
            });

            $scope.table = {
                model: NodeWithLinks,
                perPage: 100,
                supportsSearch: true
            };

            $scope.FILTERS = [
                ['all', 'All Links'],
                ['active', 'Active Links'],
                ['public', 'Public'],
                ['single_use', '1-time use'],
                ['never_expires', 'Never expires'],
                ['expiring', 'Expiring'],
                ['expired', 'Expired'],
                ['revoked', 'Revoked']
            ];

            $scope.filters = {all: true};

            $scope.showStatusColumn = Settings['cloud_platform_notarization_enabled'] || Settings['cloud_platform_sign_files_enabled'];
        }]);
